var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H13V16C13 18.2091 11.2091 20 9 20H4C1.79086 20 0 18.2091 0 16V10Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H6V9H0V4Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0H9C11.2091 0 13 1.79086 13 4V9H7V0Z",
    fill: "white"
  })));
};
export default __webpack_public_path__ + "static/media/mouse-right-button-icon.4c537b50.svg";
export { SvgComponent as ReactComponent };